import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { RootState } from '../redux/store';
import { setCustomerLegal, clearError } from '../redux/customerLegalSlice';
import { GET_CUSTOMER_LEGAL_CONTENT } from '../graphql/queries';

export const useCustomerLegal = () => {
  const dispatch = useDispatch();
  const customerLegal = useSelector((state: RootState) => state.customerLegal);

  const { data: legalData, loading: legalLoading, error: legalError, refetch: refetchLegal } = useQuery(GET_CUSTOMER_LEGAL_CONTENT);

  useEffect(() => {
    if (legalData?.getCustomerLegalContent) {
      dispatch(setCustomerLegal({
        termsOfUse: legalData.getCustomerLegalContent.termsOfUse || '',
        privacyPolicy: legalData.getCustomerLegalContent.privacyPolicy || '',
        emailVerificationAcceptedTitle: legalData.getCustomerLegalContent.emailVerificationAcceptedTitle || '',
        emailVerificationAcceptedFromName: legalData.getCustomerLegalContent.emailVerificationAcceptedFromName || '',
        emailVerificationAcceptedContent: legalData.getCustomerLegalContent.emailVerificationAcceptedContent || '',
        emailVerificationCompletedTitle: legalData.getCustomerLegalContent.emailVerificationCompletedTitle || '',
        emailVerificationCompletedFromName: legalData.getCustomerLegalContent.emailVerificationCompletedFromName || '',
        emailVerificationCompletedContent: legalData.getCustomerLegalContent.emailVerificationCompletedContent || '',
      }));
      dispatch(clearError());
    }
  }, [legalData, dispatch]);


  return {
    customerLegal,
    legalData: legalData?.getCustomerLegalContent,
    loading: legalLoading || customerLegal.isLoading,
    error: legalError || customerLegal.error,
    refetchLegal,
    dispatch,
    setCustomerLegal: (data: any) => dispatch(setCustomerLegal(data)),
    clearError: () => dispatch(clearError()),
  };
};
